import { createSlice } from '@reduxjs/toolkit';

const profilesSlice = createSlice({
  name: 'profiles',
  initialState: {
    profiles: {},
  },
  reducers: {
    setProfiles: (state, action) => {
      state.profiles = action.payload;
    },
    setOtherUserProfile: (state, action) => {
      const { userId, profile } = action.payload;
      state.profiles[userId] = profile;
    },
  },
});

export const { setProfiles, setOtherUserProfile } = profilesSlice.actions;
export default profilesSlice.reducer;
